export const ltTranslations = {
    page: {
        learning: 'Mano mokymai',
        tournament: 'Turnyras',
        tournaments: 'Turnyrai',
        settings: 'Vartotojo nustatymai',
        termsConditions: 'Nuostatos ir sąlygos',
        notifications: 'Įspėjimai',
        help: 'Pagalba',
        assignments: 'Užduotys',
        performance: 'Rezultatai',
        management: 'Valdymas',
        managementUsers: 'Vartotojų profiliai',
        managementGroups: 'Vartotojų grupės',
    },
    menu: {
        buttons: {
            product: 'Produkto svetainė',
        },
    },
    footer: {
        copyright: '© 2025 RoadMaster VR. Visos teisės saugomos.',
    },
    common: {
        loading: 'Kraunama',
        daysAbbr: 'd.',
        hoursAbbr: 'val.',
        minutesAbbr: 'min.',
        status: {
            notStarted: 'Nepradėta',
            inProgress: 'Vykdoma',
            progress: 'Vykdoma',
            completed: 'Užbaigta',
            passed: 'Išlaikyta',
            failed: 'Neišlaikyta',
            running: 'Aktyvi',
            active: 'Aktyvi',
            inactive: 'Neaktyvi',
            draft: 'Juodraštis',
            ready: 'Pasirengęs',
            offline: 'Neprisijungęs',
            starting: 'Paleidžiama',
            stopped: 'Sustabdyta',
            started: 'Paleista',
            required: 'Privaloma',
            optional: 'Pasirenkama',
        },
    },
    title: {
        courseDetail: 'RoadMaster VR Kurso aprašymas',
        learnings: 'RoadMaster VR Mokymai',
        settings: 'RoadMaster VR Nustatymai',
        main: 'RoadMaster VR Mokymų platforma',
        login: 'RoadMaster VR Prisijungimas',
        reset: 'RoadMaster VR Slaptažodžio atstatymas',
        changePassword: 'RoadMaster VR Keisti slaptažodį',
        tournament: 'RoadMaster VR Turnyras',
        tournaments: 'RoadMaster VR Turnyrai',
        error: 'RoadMaster VR Klaida',
        assignments: 'RoadMaster VR Užduotys',
        titleCreate: 'Kurti naują užduotį',
        titleEdit: 'Redaguoti užduotį',
    },
    error: {
        userLearningsTitle: 'Vartotojo mokymai nepavyko',
        userPasswordTitle: 'Neteisingas vartotojo slaptažodis',
        userSettingsTitle: 'Neteisingi vartotojo nustatymai',
        loginTitle: 'Prisijungimas nepavyko',
        logoutTitle: 'Atsijungimas nepavyko',
        baseInfoTitle: 'Informacijos klaida',
        resetTitle: 'Slaptažodžio atstatymas nepavyko',
        changePasswordTitle: 'Nepavyko atkurti slaptažodį',
        missingTokenTitle: 'Trūksta nustatymo iš naujo prieigos rakto',
        missingTokenMessage: 'Atkūrimo prieigos raktas nepateiktas',
        missingUsernameTitle: 'Trūksta vartotojo vardo nuorodos',
        missingUsernameMessage: 'Trūksta vartotojo nuorodos',
        missingProgramId: 'Trūksta programos ID',
        missingLessonId: 'Trūksta pamokos ID',
        serverError: 'Serverio klaida',
    },
    success: {
        check: 'Galioja',
        userSettingsTitle: 'Sėkmingai',
        userPasswordTitle: 'Sėkmingai',
    },
    launcherUpdate: {
        title: 'Reikia atnaujinti simuliatoriaus paleidyklę.',
        message:
            'Iš naujo paleiskite RoadMaster paleidyklę (arba kompiuterį): {{computers}}. Tada versija {{version}} bus įdiegta automatiškai.',
        badge: 'Reikia atnaujinti',
    },
    pagination: {
        goTo: 'Eiti į puslapį',
        previous: 'Ankstesnis',
        next: 'Kitas',
        submit: 'Pateikti',
        of: 'iš',
        rowsPerPage: 'Eilutės per puslapį',
    },
    tournamentsPage: {
        title: 'Turnyrai',
        emptyState: 'Turnyrų sukurta nėra. Jei jums reikalingas turnyras, susisiekite su techninės pagalbos komanda.',
        headers: {
            name: 'Turnyras',
            status: 'Būsena',
            participants: 'Dalyviai',
            statsAt: 'Prasideda',
            endsAt: 'Baigiasi',
            actions: 'Veiksmai',
        },
    },
    assignmentCrudPage: {
        basicInfo: 'Pagrindinė informacija',
        titleCreate: 'Kurti naują užduotį',
        titleEdit: 'Redaguoti užduotį',
        or: 'arba',
        selectedUsers: 'Pasirinkti vartotojai',
        selectedOnly: 'Tik pasirinkti vartotojai',
        selectedContent: 'Pasirinktas turinys',
        usersSelected: 'Pasirinkti vartotojai',
        contentSelected: 'Pasirinktas turinys',
        filters: {
            show: 'Rodyti',
            searchBy: 'Ieškoti pagal',
            programs: 'Programos',
            courses: 'Kursai',
            tags: 'Žymos',
            selected_only: 'Tik pasirinktus',
            findProgramsCourses: 'Ieškoti programų ir kursų',
            findUsers: 'Ieškoti vartotojų arba vartotojų grupių',
            findProgramsCoursesPlaceholder: 'Ieškoti pagal vardą arba žymą',
            findUsersPlaceholder: 'Ieškoti pagal vardą arba vartotojų grupę',
            Days: 'Diena',
            Weeks: 'Savaitė',
            Months: 'Mėnuo',
        },
        modal: {
            titleDiscard: 'Ar tikrai norite atšaukti?',
            textDiscard: 'Pakartotinis aktyvavimas nebus galimas po užduoties deaktyvavimo.',
            titleDraft: 'Ar tikrai norite išsaugoti kaip juodraštį?',
            textDraft: 'Bus sukurtas naujas užduoties juodraštis.',
            titlePublish: 'Ar tikrai norite išsaugoti?',
            textPublish: 'Užduotis bus matoma vartotojams ir grupėms.',
            titleDeactivate: 'Ar tikrai norite deaktyvuoti užduotį?',
            textDeactivate: 'Po deaktyvavimo užduotis taps neaktyvi.',
            titleBack: 'Ar tikrai norite grįžti į užduočių sąrašą?',
            buttons: {
                cancel: 'Grįžti atgal',
                discard: 'Atšaukti',
                deactivate: 'Deaktyvuoti',
                saveDraft: 'Išsaugoti kaip juodraštį',
                savePublish: 'Išsaugoti',
                back: 'Užduočių sąrašas',
            },
        },
        buttons: {
            discard: 'Atšaukti',
            save: 'Išsaugoti',
            saveDraft: 'Išsaugoti kaip juodraštį',
            deactivate: 'Deaktyvuoti',
            savePublish: 'Išsaugoti',
            back: 'Grįžti į užduotis',
            edit: 'Redaguoti',
            cancel: 'Atšaukti',
        },
        labels: {
            name: 'Pavadinimas',
            type: 'Tipas',
            dueDate: 'Terminas',
            duration: 'Trukmė',
            requiredAssignment: 'Privaloma užduotis',
            timeFrame: 'Laikotarpis',
        },
        headers: {
            userName: 'Vartotojas',
            email: 'El. paštas',
            assignmentName: 'Pavadinimas',
            tags: 'Žymos',
            createdBy: 'Sukūrė',
            createdAt: 'Sukūrimo data',
            type: 'Tipas',
        },
    },
    assignmentsPage: {
        buttons: {
            create: 'Kurti užduotį',
        },
        filters: {
            assignmentName: 'Ieškoti',
            type: 'Tipas',
            status: 'Statusas',
            placeholder: 'Ieškoti',
            all: 'Visi',
        },
        headers: {
            assignmentName: 'Pavadinimas',
            type: 'Tipas',
            status: 'Būsena',
            learners: 'Dalyviai',
            createdBy: 'Sukūrė',
            createdAt: 'Sukūrimo data',
            duaDate: 'Atlikti iki',
            actions: 'Veiksmai',
        },
        tooltips: {
            edit: 'Redaguoti',
            assignmentDetails: 'Užduoties informacija',
            performance: 'Rezultatai',
        },
        title: 'Užduotys',
        subTitle: 'Užduotys',
    },
    assignmentManagePage: {
        headers: {
            computer: 'Kompiuteris',
            status: 'Būsena',
            driver: 'Dalyvis',
            lesson: 'Pamoka',
            type: 'Tipas',
            mode: 'Režimas',
            actions: 'Veiksmai',
            totalScore: 'Bendras balas',
            attempt: 'Bandymų skaičius',
            simulator: 'Simuliatorius',
        },
        driverRow: {
            driverName: 'Dalyvis',
            internalId: 'Vidinis ID',
            country: 'Šalis',
            completionRate: 'Užbaigimo rodiklis',
            completion: 'Užbaigimas',
        },
        buttons: {
            stop: 'Stabdyti',
            view: 'Peržiūrėti',
            run: 'Paleisti',
            starting: 'Paleidžiama...',
        },
        actions: {
            expandAll: 'Išskleisti visus',
            collapseAll: 'Suskleisti visus',
        },
        search: {
            placeholder: 'Ieškoti vairuotojų pagal vardą, ID ar šalį...',
        },
        simulator: {
            selectSimulator: 'Pasirinkite simuliatorių',
        },
        status: {
            notStarted: 'Nepradėta',
            completed: 'Užbaigta',
            inProgress: 'Vykdoma',
            running: 'Aktyvi',
        },
        sort: {
            sortBy: 'Rūšiuoti pagal',
            sortDriversBy: 'Rūšiuoti vairuotojus pagal',
            default: 'Numatytasis',
            completionDesc: 'Užbaigimo % (nuo didžiausio)',
            completionAsc: 'Užbaigimo % (nuo mažiausio)',
            avgScoreDesc: 'Vid. balas (nuo didžiausio)',
            avgScoreAsc: 'Vid. balas (nuo mažiausio)',
            statusProgress: 'Pirmiausia vykdomos',
            statusNotStarted: 'Pirmiausia nepradėtos',
            statusCompleted: 'Pirmiausia užbaigtos',
            attemptsDesc: 'Daugiausia bandymų',
            attemptsAsc: 'Mažiausia bandymų',
        },
        modals: {
            notes: {
                title: 'Pridėti instruktoriaus pastabą',
                subtitle: 'Pridėti pastabą',
                placeholder: 'Įveskite pastabą čia...',
                cancel: 'Atšaukti',
                save: 'Išsaugoti pastabą',
            },
            config: {
                title: 'Pamokos nustatymai',
                simulationType: 'Įrenginio tipas',
                lessonLanguage: 'Pamokos kalba',
                aiTraffic: 'AI eismas',
                timeOfDay: 'Paros metas',
                weather: 'Orai',
                vrTutorial: 'VR pamoka',
                lessonDefault: 'Pamokos numatytasis',
                vr: 'VR',
                screen: 'Ekranas',
                yes: 'Taip',
                no: 'Ne',
                day: 'Diena',
                night: 'Naktis',
                clear: 'Giedra',
                rain: 'Lietus',
                storm: 'Audra',
                cancel: 'Atšaukti',
                save: 'Išsaugoti',
                languages: {
                    eng: 'EN',
                    lt: 'LT',
                    ru: 'RU',
                },
            },
            computerStatus: {
                component: 'Komponentas',
                status: 'Būsena',
                notes: 'Pastabos',
                lastOnline: 'Paskutinis prisijungimas',
                refreshing: 'Atnaujinama',
                refresh: 'Atnaujinti',
                close: 'Uždaryti',
            },
            statusChange: {
                title: 'Keisti pamokos būseną',
                message: 'Pakeisti {{driver}} - {{lesson}} būseną į „{{status}}"? Tai paveiks užbaigimo statistiką.',
                confirm: 'Keisti būseną',
                cancel: 'Atšaukti',
            },
        },
        errors: {
            createLessonAttemptFailed: 'Nepavyko paleisti pamokos. Bandykite dar kartą.',
            updateLessonAttemptStatusFailed: 'Nepavyko atnaujinti pamokos būsenos. Bandykite dar kartą.',
        },
    },
    performancePage: {
        title: 'Vairuotojų pamokų atlikimas',
        export: 'Eksportuoti',
        filters: {
            team: 'Dalyviai',
            content: 'Turinys',
            totalScore: 'Bendras balas',
            date: 'Data',
            allDrivers: 'Visi vairuotojai',
            byDriver: 'Pagal vairuotoją',
            byGroup: 'Pagal grupę',
            search: 'Paieška',
            noGroupsAvailable: 'Grupių nėra',
            allContent: 'Visas turinys',
            byLesson: 'Pagal pamoką',
            byAssignment: 'Pagal užduotį',
            lessons: 'Pamokos',
            assignments: 'Užduotys',
            allLessons: 'Visos pamokos',
            lastAttempt: 'Paskutinis bandymas',
            onlyExams: 'Tik egzaminai',
            clear: 'Išvalyti',
            apply: 'Taikyti',
            last1Month: 'Paskutinis mėnuo',
            last2Months: 'Paskutiniai 2 mėnesiai',
            last3Months: 'Paskutiniai 3 mėnesiai',
            last6Months: 'Paskutiniai 6 mėnesiai',
            last12Months: 'Paskutiniai 12 mėnesių',
            timeFrame: 'Laikotarpis',
        },
        kpi: {
            driversEnrolled: 'Registruoti vairuotojai',
            avgTimeSpent: 'Vidutinis mokymosi laikas',
            avgScore: 'Vidutinis balas',
            completionRate: 'Užbaigimo procentas',
            kpi: 'KPI',
            kpis: 'KPI',
        },
        table: {
            lesson: 'Pamoka',
            type: 'Tipas',
            mode: 'Režimas',
            status: 'Būsena',
            totalScore: 'Bendras balas',
            startDate: 'Pradžios data/Laikas',
            sessionDuration: 'Sesijos trukmė',
            attempt: 'Bandymas',
            details: 'Detalės',
        },
        driverRow: {
            internalId: 'Vidinis ID',
            country: 'Šalis',
            completionRate: 'Užbaigimo rodiklis',
            completion: 'Užbaigimas',
        },
        actions: {
            expandAll: 'Išskleisti visus',
            collapseAll: 'Suskleisti visus',
        },
        search: {
            placeholder: 'Ieškoti vairuotojų pagal vardą, ID ar šalį...',
        },
        status: {
            notStarted: 'Nepradėta',
            completed: 'Užbaigta',
            inProgress: 'Vykdoma',
            progress: 'Vykdoma',
            running: 'Aktyvi',
            passed: 'Išlaikyta',
            failed: 'Neišlaikyta',
        },
        sort: {
            sortBy: 'Rūšiuoti pagal',
            sortDriversBy: 'Rūšiuoti vairuotojus pagal',
            default: 'Numatytasis',
            completionDesc: 'Užbaigimo % (nuo didžiausio)',
            completionAsc: 'Užbaigimo % (nuo mažiausio)',
            avgScoreDesc: 'Vid. balas (nuo didžiausio)',
            avgScoreAsc: 'Vid. balas (nuo mažiausio)',
            statusProgress: 'Pirmiausia vykdomi',
            statusNotStarted: 'Pirmiausia nepradėti',
            statusCompleted: 'Pirmiausia užbaigti',
            attemptsDesc: 'Daugiausia bandymų',
            attemptsAsc: 'Mažiausia bandymų',
        },
        selection: {
            of: 'iš',
            drivers: 'vairuotojų',
        },
        details: {
            driverName: 'Vairuotojo vardas',
            internalId: 'Vidinis ID',
            country: 'Šalis',
            completionRate: 'Užbaigimo rodiklis',
            startDate: 'Pradžios data',
            startDateTime: 'Pradžios data/Laikas',
            generalInfo: 'Bendra informacija',
        },
        metrics: {
            results: 'Rezultatai',
            yourResult: 'Jūsų rezultatas',
            goal: 'Tikslas',
        },
        emptyState: {
            title: 'Nėra duomenų',
            message:
                'Nerasta jokių atlikimo duomenų pagal pasirinktus filtrus. Pabandykite pakeisti filtrus, kad matytumėte rezultatus.',
        },
    },
    error404Page: {
        title: 'Puslapis nerastas!',
        subTitle: 'Klaida: 404',
        text: 'Tokio URL nėra',
    },
    error500Page: {
        title: 'Vidinė serverio klaida',
        subTitle: 'Klaida: 500',
        text: 'Serveris aptiko vidinę klaidą arba netinkamą konfigūraciją ir negalėjo įvykdyti Jūsų užklausos',
    },
    tournamentPage: {
        leaderboard: 'Lyderiai',
        join: 'Prisijunk',
        tournament: 'į turnyrą!',
        emptyState: 'Turnyrų sukurta nėra. Jei jums reikalingas turnyras, susisiekite su techninės pagalbos komanda.',
        form: {
            playerName: 'Žaidėjo Vardas',
            computer: 'Kompiuteris',
            start: 'Pradėti',
            stop: 'Stabdyti',
        },
        banner: {
            total: 'IŠ VISO',
            drivers: 'VAIRUOTOJŲ',
            tournament: 'TURNYRAS',
            ends: 'BAIGIASI',
            time: 'LAIKO',
            left: 'LIKO',
            hours: 'Valandos',
            minutes: 'Minutės',
            seconds: 'Sekundės',
            winners: 'Lyderiai',
        },
        session: {
            totalScore: 'BENDRAS BALAS',
            speedingFine: 'BAUDA UŽ GREIČIO VIRŠIJIMĄ',
            time: 'LAIKAS',
            conesHit: 'NUMUŠTI KŪGIAI',
        },
    },
    courseDetailPage: {
        buttons: {
            start: 'Pradėti',
            continue: 'Tęsti',
            retake: 'Pakartoti',
            next: 'Kitas',
            submit: 'Submit',
            terminate: 'Terminate lesson',
        },
        modal: {
            titleDiscard: 'Ar tikrai norite nutraukti šią pamoką?',
            textDiscard: 'Jei taip, Jūsų progresas bus prarastas.',
            buttons: {
                cancel: 'Atšaukti',
                discard: 'Grįžti į pamoką',
            },
        },
        popover: {
            launch: 'Pradėti',
            form: {
                computer: 'Pasirinkite simuliatorių',
                start: 'Pradėti',
                stop: 'Atšaukti',
            },
        },
        keyKpis: {
            title: 'Pagrindinė pamokos statistika',
        },
        nonKeyKpis: {
            title: 'Peržiūra',
        },
        kpis: {
            score: 'Balas',
            goal: 'Tikslas',
        },
        yourResult: 'Jūsų rezultatas',
        status: {
            notStarted: 'Nepradėta',
            progress: 'Vykdoma',
            passed: 'Išlaikyta',
            failed: 'Neišlaikyta',
            running: 'Aktyvi',
        },
        quizResults: {
            thanks: 'Ačiū!',
            completed: 'Užduotis baigta',
        },
        surveyResults: {
            thanks: 'Ačiū!',
            completed: 'Apklausa baigta',
        },
        type: 'Tipas',
        yourAnswer: 'Atsakymas',
        submitInfo: 'Liko klausimų',
        menu: 'Pamokos meniu',
        question: 'Klausimas',
        description: 'Pamokos aprašymas',
        contentDescription: 'Norėdami atrakinti turinį, pradėkite pamoką',
        content: 'Turinys',
        collapse: 'Arrow down',
        expand: 'Arrow up',
        assigned: 'PRISKIRTAS',
        dueby: 'ATLIKTI IKI',
        completed: 'ATLIKTAS',
        completedIn: 'ATLIKTAS PER',
        started: 'PRADĖTAS',
        duration: 'TRUKMĖ',
        hour: 'val.',
        min: 'min.',
        sec: 'sec.',
        lesson: 'Pamoka',
        drop: 'Įrašykite atsakymą čia',
        parkingPosition: 'Parkavimo pozicija',
    },
    learningsPage: {
        emptyState: 'Nėra priskirtų pamokų',
        meta: {
            finishedTotal: 'Programų progresas',
            coursesLessons: 'Kursų ir pamokų progresas',
            deadline: 'Artimiausias terminas',
        },
        data: {
            program: {
                title: 'PROGRAMA',
                collapse: 'Arrow down',
                expand: 'Arrow up',
                course: 'KURSAS',
            },
            course: {
                buttons: {
                    start: 'Pradėti',
                    continue: 'Tęsti',
                    starting: 'Paleidžiama...',
                },
                collapse: 'Arrow down',
                expand: 'Arrow up',
                assigned: 'PRISKIRTAS',
                dueby: 'ATLIKTI IKI',
            },
            lesson: {
                lesson: 'Pamoka',
                locked: 'Užrakinta',
                completed: 'Atlikta',
            },
            overview: {
                buttons: {
                    more: 'Rodyti daugiau',
                    less: 'Rodyti mažiau',
                },
                lessonsLeft: 'ATLIKTOS PAMOKOS',
                dueby: 'ATLIKTI IKI',
                assigned: 'PRISKIRTA',
                duration: 'TRUKMĖ',
            },
        },
        title: 'Mano Mokymai',
    },
    settingsPage: {
        buttons: {
            save: 'Išsaugoti',
            update: 'Atnaujinti slaptažodį',
            cancel: 'Atšaukti',
        },
        labels: {
            name: 'Vardas',
            phoneNumber: 'Telefono numeris',
            jobRole: 'Pareigos',
            surname: 'Pavardė',
            company: 'Įmonė',
            cardNumber: 'Tachografo kortelės numeris',
            email: 'El. paštas',
            password: 'Slaptažodis',
            lastUpdated: 'Paskutinį kartą pakeistas',
            changePassword: 'Keisti slaptažodį',
            selectLanguage: 'Pasirinkti kalbą',
        },
        info: 'Susisiekite su savo Instruktoriumi, jei reikia atnaujinti profilio informaciją.',
        form: {
            reminders: 'Priminimai',
            marketingMessages: 'Rinkodaros pranešimai',
            language: 'Kalba',
            oldPassword: 'Senas slaptažodis',
            newPassword: 'Naujas slaptažodis',
            confirmNewPassword: 'Pakartokite naują slaptažodį',
            passwordError: 'Nesutampa slaptažodžiai',
        },
        title: 'Vartotojo nustatymai',
    },
    loginPage: {
        buttons: {
            contact: 'Susisiekite su mumis',
            login: 'Prisijungti',
        },
        form: {
            email: 'El. paštas',
            emailError: 'Įveskite teisingą elektroninio pašto adresą',
            password: 'Slaptažodis',
            forgotPassword: 'Pamiršau slaptažodį',
            rememberMe: 'Įsiminti',
        },
        title: 'Prisijungti į mokymų platformą',
        subtitle: 'Dar ne narys?',
    },
    resetPage: {
        buttons: {
            back: 'Grįžti į prisijungimo langą',
            reset: 'Gauti slaptažodžio atstatymo nuorodą',
        },
        form: {
            email: 'Įveskite elektroninio pašto adresą',
            emailError: 'Neteisingas elektroninio pašto adresas',
        },
        title: 'Atstatyti slaptažodį',
    },
    changePasswordPage: {
        buttons: {
            back: 'Grįžti į prisijungimo langą',
            change: 'Pakeisti',
        },
        form: {
            password: 'Įveskite naują slaptažodį',
            repeatPassword: 'Pakartokite slaptažodį',
            passwordError: 'Nesutampa slaptažodžiai',
        },
        title: 'Pakeisti slaptažodį',
    },
    userProfiles: {
        headers: {
            lmsId: 'LMS ID',
            email: 'El. paštas',
            firstName: 'Vardas',
            lastName: 'Pavardė',
            employeeId: 'Darbuotojo ID',
            registrationDate: 'Registracijos data',
            status: 'Būsena',
            actions: 'Veiksmai',
        },
        search: {
            placeholder: 'Ieškoti pagal el. paštą, vardą ar darbuotojo ID...',
        },
        tooltips: {
            edit: 'Redaguoti',
            deactivate: 'Išjungti',
            activate: 'Aktyvinti',
            remove: 'Pašalinti iš sąsajos',
        },
        errors: {
            removeFailed: 'Nepavyko pašalinti vartotojo. Bandykite dar kartą.',
            toggleFailed: 'Nepavyko pakeisti vartotojo būsenos. Bandykite dar kartą.',
            loadFailed: 'Nepavyko įkelti vartotojų. Bandykite dar kartą.',
            updateFailed: 'Nepavyko atnaujinti vartotojo duomenų. Bandykite dar kartą.',
        },
        modals: {
            removeUser: {
                title: 'Pašalinti vartotoją iš sistemos?',
                message:
                    'Šis veiksmas pašalins vartotoją iš visų matomų LMS sąrašų. Vartotojas nebebus pasiekiamas naujuose pavedimuose.',
                cancel: 'Atšaukti',
                confirm: 'Pašalinti',
            },
        },
        createUser: 'Sukurti vartotoją',
    },
    editUser: {
        title: 'Atnaujinti vartotoją',
        lmsId: 'LMS ID',
        email: 'El. paštas',
        firstName: 'Vardas',
        lastName: 'Pavardė',
        employeeId: 'Darbuotojo ID',
        company: 'Įmonė',
        registrationDate: 'Registracijos data',
        language: 'Kalba',
        status: 'Būsena',
        active: 'Aktyvus',
        inactive: 'Neaktyvus',
        newPassword: 'Naujas slaptažodis',
        newPasswordHelper: 'Palikite tuščią, jei nenorite keisti',
        userGroups: 'Vartotojų grupės',
        groupsDisclaimer: 'Grupės narystė lemia dalyvavimą būsimuose pavedimuose. Esami pavedimai nepakeičiami.',
        save: 'Išsaugoti',
        discard: 'Atmesti',
        sendReset: 'Siųsti slaptažodžio atstatymo el. laišką',
        updateSuccess: 'Vartotojo duomenys sėkmingai atnaujinti',
        resetSent: 'Slaptažodžio atstatymo el. laiškas išsiųstas',
        requiredFieldsError: 'Užpildykite visus privalomus laukus.',
        english: 'Anglų',
        lithuanian: 'Lietuvių',
        russian: 'Rusų',
    },
    userGroups: {
        headers: {
            groupId: 'Grupės ID',
            name: 'Pavadinimas',
            description: 'Aprašymas',
            userCount: 'Vartotojai',
        },
        emptyState: 'Grupių dar nesukurta',
        createGroup: 'Sukurti grupę',
        search: 'Ieškoti grupių...',
        tooltips: {
            edit: 'Redaguoti grupę',
            remove: 'Pašalinti grupę',
            removeDisabled:
                'Grupės negalima pašalinti, kol jai priskirta vartotojų. Išimkite visus vartotojus iš grupės.',
        },
        modals: {
            removeGroup: {
                title: 'Ištrinti grupę?',
                message:
                    'Šis veiksmas pašalins grupę iš aktyvaus LMS naudojimo. Grupei priskirti vartotojai nebus ištrinti. Istoriniai duomenys apie ankstesnius pavedimus ir našumą išliks nepakeisti.',
                confirm: 'Pašalinti',
                cancel: 'Atšaukti',
            },
        },
        errors: {
            removeFailed: 'Nepavyko pašalinti grupės. Bandykite dar kartą.',
        },
        success: {
            removed: 'Grupė sėkmingai pašalinta',
        },
    },
    createGroup: {
        title: 'Sukurti grupę',
        groupName: 'Grupės pavadinimas',
        description: 'Aprašymas',
        create: 'Sukurti',
        discard: 'Atmesti',
        users: {
            title: 'Priskirti vartotojus',
            searchPlaceholder: 'Ieškoti pagal vardą, pavardę ar darbuotojo ID...',
            add: 'Pridėti',
            remove: 'Pašalinti {{name}}',
            addedTitle: 'Priskirti vartotojai',
            columns: {
                name: 'Vardas',
                email: 'El. paštas',
                employeeId: 'Darbuotojo ID',
            },
        },
        success: {
            created: 'Grupė sėkmingai sukurta',
        },
        errors: {
            nameRequired: 'Grupės pavadinimas yra privalomas.',
            createFailed: 'Nepavyko sukurti grupės. Bandykite dar kartą.',
        },
    },
    editGroup: {
        title: 'Redaguoti grupę',
        general: 'Bendra',
        groupName: 'Grupės pavadinimas',
        description: 'Aprašymas',
        users: {
            title: 'Priskirti vartotojai',
            searchPlaceholder: 'Ieškoti pagal vardą, pavardę ar darbuotojo ID...',
            add: 'Pridėti',
            remove: 'Pašalinti {{name}}',
            addedTitle: 'Priskirti vartotojai',
            columns: {
                name: 'Vardas',
                email: 'El. paštas',
                employeeId: 'Darbuotojo ID',
            },
            disclaimer: 'Grupės narystė lemia dalyvavimą būsimuose pavedimuose. Esami pavedimai nepakeičiami.',
        },
        save: 'Išsaugoti',
        discard: 'Atmesti',
        confirmModal: {
            title: 'Atnaujinti grupę?',
            message:
                'Ši grupė naudojama pavedimuose. Narių pakeitimai taikomi tik būsimiems pavedimams. Esami pavedimai nepakeičiami. Grupės pavadinimo atnaujinimai taikomi nedelsiant.',
            save: 'Išsaugoti',
            discard: 'Atmesti',
        },
        success: {
            updated: 'Grupė sėkmingai atnaujinta',
        },
        errors: {
            nameRequired: 'Grupės pavadinimas būtinas.',
            updateFailed: 'Nepavyko atnaujinti grupės. Bandykite dar kartą.',
        },
    },
    createUser: {
        title: 'Sukurti vartotoją',
        subtitle: 'Keli vartotojai',
        upload: {
            dropzone: 'Nuvilkite CSV failą čia arba spustelėkite norėdami pasirinkti',
            selected: 'Pasirinktas failas:',
            template: 'Atsisiųsti CSV šabloną',
            validate: 'Tikrinti failą',
            fileTypes: 'Tik CSV failai (.csv)',
            maxRows: 'Maksimum 1000 eilučių vienam įkėlimui',
        },
        validation: {
            title: 'Patikrinimo rezultatai',
            validRow: 'Tinkama',
            summary: {
                total: 'Iš viso eilučių',
                valid: 'Tinkamos eilutės',
                invalid: 'Netinkamos eilutės',
            },
            uploadButton: 'Įkelti vartotojus',
            discardButton: 'Atmesti',
            skipNote: 'Bus sukurtos tik tinkamos eilutės. Netinkamos eilutės bus praleistos.',
        },
        results: {
            title: 'Importo rezultatai',
            created: '{{count}} vartotojai sėkmingai sukurti',
            failed: '{{count}} eilutės nepavyko',
            done: 'Atlikta',
            resetSent: 'Visiems sukurtiems vartotojams bus išsiųsti slaptažodžio atstatymo el. laiškai.',
        },
        errors: {
            validationFailed: 'Patikrinimas nepavyko. Bandykite dar kartą.',
            importFailed: 'Importas nepavyko. Bandykite dar kartą.',
        },
        columns: {
            email: 'El. paštas',
            firstName: 'Vardas',
            lastName: 'Pavardė',
            employeeId: 'Darbuotojo ID',
            language: 'Kalba',
            status: 'Būsena',
            groups: 'Grupės',
            errors: 'Klaidos',
        },
        processing: 'Apdorojami vartotojai, palaukite...',
        singleUser: {
            tabLabel: 'Vienas vartotojas',
            email: 'El. paštas',
            firstName: 'Vardas',
            lastName: 'Pavardė',
            employeeId: 'Darbuotojo ID',
            password: 'Laikinas slaptažodis',
            language: 'Kalba',
            status: 'Būsena',
            active: 'Aktyvus',
            inactive: 'Neaktyvus',
            english: 'Anglų',
            russian: 'Rusų',
            lithuanian: 'Lietuvių',
            userGroups: 'Vartotojų grupės',
            groupsDisclaimer: 'Grupės narystė lemia dalyvavimą būsimuose pavedimuose. Esami pavedimai nepakeičiami.',
            create: 'Sukurti',
            discard: 'Atmesti',
            createSuccess: 'Vartotojas sėkmingai sukurtas',
            errors: {
                emailRequired: 'El. paštas yra privalomas',
                emailInvalid: 'Įveskite tinkamą el. pašto adresą',
                emailAlreadyExists: 'Vartotojas su tokiu el. paštu jau egzistuoja',
                firstNameRequired: 'Vardas yra privalomas',
                lastNameRequired: 'Pavardė yra privaloma',
                passwordRequired: 'Slaptažodis yra privalomas',
                requiredFields: 'Užpildykite visus privalomus laukus',
                createFailed: 'Nepavyko sukurti vartotojo. Bandykite dar kartą.',
            },
        },
        bulkUser: {
            tabLabel: 'Keli vartotojai',
        },
    },
    kpis: {
        measures: {
            km: 'km',
            l100: 'l/100',
            percent: '%',
        },
        eco: {
            ecoScore: {
                name: 'EKO Balas',
                tooltip: 'Bendras EKO balas',
            },
            fuelConsuption: {
                name: 'Kuro suvartojimas',
                tooltip: 'Vidutinis kuro suvartojimas per sesiją',
            },
            overspeed: {
                name: 'Greičio viršyjimas',
                tooltip: 'Kiek procentų kelio važiuota viršyjant leistiną greitį',
            },
            harshAcceleration: {
                name: 'Staigus greitėjimas',
                tooltip: 'Kiek procentų kelio važiuota per staigiai greitėjant',
            },
            coasting: {
                name: 'Riedėjimas',
                tooltip: 'Procentas nuriedėto kelio atkarpoje, kurioje reikėjo riedėti',
            },
            notOptimalRpm: {
                name: 'Aukštos apsukos',
                tooltip: 'Kiek procentų kelio važiuota greitėjant ir viršijant žalią apsukų (RPM) ribą',
            },
            cruiseControl: {
                name: 'Kruizo kontrolė',
                tooltip: 'Kiek procentų kelio, per kurį buvo galima naudoti kruizą, buvo nuvažiuota naudojant kruizą',
            },
            ccEfficiency: {
                name: 'Kruizo efektyvumas',
                tooltip: 'Baudos taškai už neteisingą kruizo naudojimą',
            },
            brakingCountVsStops: {
                name: 'Stabdymai/Sustojimai',
                tooltip: 'Stabdžio pedalo paspaudimai iki pilno sustojimo',
            },
            harshBraking: {
                name: 'Staigus stabdymas',
                tooltip: 'Balas apskaičiuotas vertinant staigaus stabdymo atvejus',
            },
            speeding: {
                name: 'Greičio viršijimas',
                tooltip: 'Kiek procentų kelio važiuota viršyjant leistiną greitį',
            },
        },
    },
    lessonType: {
        '3D': 'Simuliatorius',
        '360': 'VR ausinės',
        PDF: 'PDF',
        Survey: 'Apklausa',
        Text: 'Tekstas',
    },
    datepicker: {
        placeholder: 'MM/DD/YYYY',
        openButton: 'Atidaryti datos parinkiklį',
        previousMonth: 'Ankstesnis mėnuo',
        nextMonth: 'Kitas mėnuo',
        clear: 'Išvalyti',
        ok: 'Gerai',
        weekdays: ['Pirm', 'Antr', 'Treč', 'Ketv', 'Penkt', 'Šešt', 'Sekm'],
        months: [
            'Sausis',
            'Vasaris',
            'Kovas',
            'Balandis',
            'Gegužė',
            'Birželis',
            'Liepa',
            'Rugpjūtis',
            'Rugsėjis',
            'Spalis',
            'Lapkritis',
            'Gruodis',
        ],
    },
};
